module.exports = __webpack_public_path__ + "assets/img/kidroom_12.ce03fd10.jpg";